import { useOnboarding } from "./useOnboarding";

/**
 * Kept as an alias for the login/registration call sites; useOnboarding
 * now performs the same network-refetch-then-route on every navigation.
 */
export const useOnboardingSavePoint = () => {
  const { resetToNext } = useOnboarding();

  return [resetToNext] as const;
};
